/* Dansk katalog for locale-commerce-preferences-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'pref.salesMode': 'Standardvisning for nyt salg',
  'pref.salesModeSub': 'Bruges til faktura, tilbud, ordrebekræftelse, kreditnota og andet salg. Du kan skifte visning midlertidigt i formularen.',
  'pref.purchaseMode': 'Standardvisning for nye køb',
  'pref.purchaseModeSub': 'Vælg, om nye køb normalt skal åbnes trin for trin eller med hele formularen på én side.',
  'pref.mode.firstChoiceHelp': 'Valget bliver din standard. Du kan skifte visning i formularen eller ændre standarden senere under Indstillinger → Præferencer.',
  'pref.mode.saveFailed': 'Visningen blev skiftet, men standardvalget kunne ikke gemmes. Prøv igen under Indstillinger → Præferencer.',
  'pref.mode.unsupported': 'Ugyldigt visningsvalg.',
});
